import { CoordinatorService } from "./coordinator.service"

export type EWPAR = {
    tag: string
    title: string
    url: string
}
export class ExternalWeb implements EWPAR {
    tag: string
    title: string
    url: string

    constructor(private coords: CoordinatorService,
        params: EWPAR
    ) {
        this.tag = params.tag
        this.title = params.title
        this.url = params.url
        this.coords.externalWeb$.add(this)
    }

    private _href(term: string) {
        term = encodeURIComponent(term)
        return this.url.replace(/\${(.+?)}/, term)
    }

    run(term: string) {
        const url = this._href(term)
        this.coords.externalWeb$.open(url, `_${this.tag}`)
    }

    a() {
        const xitm = this.coords.resultList$.activeItem
        if (!xitm) return ""

        const tLabel = this.coords.text("title")
        const termLs = [
            [tLabel, xitm.title],
            [`"${tLabel}"`, `"${xitm.title}"`]]

        const doi = xitm.get("doi")
        if (doi)
            termLs.push(["doi", doi])


        return termLs.map(tpl =>
            `<a href="${this._href(tpl[1]!)}" 
            target="_${this.tag}">${tpl[0]}</a>`).join(" | ")


    }

}
